// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__YMfSD","alert":"styles_alert__hkq-O","notiMessage":"styles_notiMessage__U6Sp7","notificationWrapper":"styles_notificationWrapper__rRIuA"};